<template>

	<div class='container'>
		<h1 class='title-text'> NEL Map </h1>
		<div>
			<svg></svg>
			<img src='https://datagovsg.github.io/ttt-frontend/dist/nel-map.png'>
		</div>
	</div>

</template>

<script>

import _ from 'lodash'
import axios from 'axios'
import * as d3 from "d3";

export default {
	props: ["trainStatusData", "idToPV"],
	data () {
		return {
	    	polygonArray: [],
	        leftBoundArray: [],
	        rightBoundArray: [],
	      	stationNames: [
			    {'name': 'NE1 - HarbourFront', 'circleX': '393', 'circleY': '395', 'circleR': '5'},
			    {'name': 'NE3 - Outram Park', 'circleX': '343', 'circleY': '446', 'circleR': '8'},
			    {'name': 'NE4 - Chinatown','circleX': '305', 'circleY': '243', 'circleR': '8'},
			    {'name': 'NE5 - Clarke Quay','circleX': '343', 'circleY': '280', 'circleR': '5'},
			    {'name': 'NE6 - Dhoby Ghaut','circleX': '377', 'circleY': '313', 'circleR': '5'},
			    {'name': 'NE7 - Little India','circleX': '440', 'circleY': '348', 'circleR': '6'},
			    {'name': 'NE8 - Farrer Park','circleX': '470', 'circleY': '320', 'circleR': '5'},
			    {'name': 'NE9 - Boon Keng','circleX': '494', 'circleY': '295', 'circleR': '5'},
			    {'name': 'NE10 - Potong Pasir','circleX': '508', 'circleY': '262', 'circleR': '5'},
			    {'name': 'NE11 - Woodleigh','circleX': '508', 'circleY': '228', 'circleR': '5'},
			    {'name': 'NE12 - Serangoon','circleX': '508', 'circleY': '194', 'circleR': '6'},
			    {'name': 'NE13 - Kovan','circleX': '508', 'circleY': '150', 'circleR': '6'},
			    {'name': 'NE14 - Hougang','circleX': '492', 'circleY': '132', 'circleR': '5'},
			    {'name': 'NE15 - Buangkok','circleX': '471', 'circleY': '112', 'circleR': '5'},
			    {'name': 'NE16 - Sengkang','circleX': '443', 'circleY': '84', 'circleR': '6'},
			    {'name': 'NE17 - Punggol','circleX': '402', 'circleY': '62', 'circleR': '5'}],

			clockWiseTrains: [{'startX': 343, 'startY': 466, 'rotation': 270},
			{'startX': 367, 'startY': 439, 'rotation': 270},
			{'startX': 397, 'startY': 409, 'rotation': 270},
			{'startX': 413, 'startY': 393, 'rotation': 270},
			{'startX': 288, 'startY': 248, 'rotation': 0},
			{'startX': 303, 'startY': 263, 'rotation': 0},
			{'startX': 323, 'startY': 283, 'rotation': 0},
			{'startX': 340, 'startY': 300, 'rotation': 0},
			{'startX': 360, 'startY': 320, 'rotation': 0},
			{'startX': 380, 'startY': 340, 'rotation': 0},
			{'startX': 443, 'startY': 363, 'rotation': 270},
			{'startX': 456, 'startY': 350, 'rotation': 270},
			{'startX': 471, 'startY': 334, 'rotation': 270},
			{'startX': 481, 'startY': 324, 'rotation': 270},
			{'startX': 496, 'startY': 309, 'rotation': 270},
			{'startX': 503, 'startY': 302, 'rotation': 270},
			{'startX': 522, 'startY': 273, 'rotation': 225},
			{'startX': 522, 'startY': 257, 'rotation': 225},
			{'startX': 522, 'startY': 238, 'rotation': 225},
			{'startX': 522, 'startY': 220, 'rotation': 225},
			{'startX': 522, 'startY': 204, 'rotation': 225},
			{'startX': 522, 'startY': 181, 'rotation': 225},
			{'startX': 522, 'startY': 161, 'rotation': 225},
			{'startX': 518, 'startY': 141, 'rotation': 180},
			{'startX': 508, 'startY': 131, 'rotation': 180},
			{'startX': 498, 'startY': 121, 'rotation': 180},
			{'startX': 488, 'startY': 111, 'rotation': 180},
			{'startX': 475, 'startY': 98, 'rotation': 180},
			{'startX': 460, 'startY': 83, 'rotation': 180},
			{'startX': 446, 'startY': 67, 'rotation': 180},
			{'startX': 413, 'startY': 47, 'rotation': 135},
			{'startX': 390, 'startY': 47, 'rotation': 135},
			{'startX': 363, 'startY': 47, 'rotation': 135},
			{'startX': 340, 'startY': 47, 'rotation': 135},
			{'startX': 317, 'startY': 47, 'rotation': 135},
			{'startX': 280, 'startY': 56, 'rotation': 90},
			{'startX': 265, 'startY': 71, 'rotation': 90},
			{'startX': 245, 'startY': 91, 'rotation': 90},
			{'startX': 230, 'startY': 106, 'rotation': 90},
			{'startX': 212, 'startY': 124, 'rotation': 90},
			{'startX': 192, 'startY': 144, 'rotation': 90},
			{'startX': 180, 'startY': 156, 'rotation': 90},
			{'startX': 164, 'startY': 172, 'rotation': 90},
			{'startX': 147, 'startY': 189, 'rotation': 90},
			{'startX': 132, 'startY': 203, 'rotation': 90},
			{'startX': 119, 'startY': 216, 'rotation': 90},
			{'startX': 100, 'startY': 237, 'rotation': 90},
			{'startX': 86, 'startY': 251, 'rotation': 90},
			{'startX': 71, 'startY': 266, 'rotation': 90},
			{'startX': 58, 'startY': 297, 'rotation': 0},
			{'startX': 70, 'startY': 310, 'rotation': 0},
			{'startX': 83, 'startY': 323, 'rotation': 0},
			{'startX': 95, 'startY': 335, 'rotation': 0},
			{'startX': 107, 'startY': 347, 'rotation': 0},
			{'startX': 122, 'startY': 362, 'rotation': 0},
			{'startX': 135, 'startY': 375, 'rotation': 0},
			{'startX': 150, 'startY': 390, 'rotation': 0},
			{'startX': 165, 'startY': 405, 'rotation': 0},
			{'startX': 178, 'startY': 418, 'rotation': 0}],

			antiClockWiseTrains: [{'startX': 338, 'startY': 423, 'rotation': 90},
			{'startX': 363, 'startY': 400, 'rotation': 90},
			{'startX': 389, 'startY': 376, 'rotation': 90},
			{'startX': 408, 'startY': 358, 'rotation': 90},
			{'startX': 325, 'startY': 237, 'rotation': 180},
			{'startX': 342, 'startY': 252, 'rotation': 180},
			{'startX': 362, 'startY': 271, 'rotation': 180},
			{'startX': 380, 'startY': 288, 'rotation': 180},
			{'startX': 397, 'startY': 307, 'rotation': 180},
			{'startX': 417, 'startY': 328, 'rotation': 180},
			{'startX': 435, 'startY': 329, 'rotation': 90},
			{'startX': 450, 'startY': 315, 'rotation': 90},
			{'startX': 467, 'startY': 301, 'rotation': 90},
			{'startX': 478, 'startY': 292, 'rotation': 90},
			{'startX': 492, 'startY': 279, 'rotation': 90},
			{'startX': 500, 'startY': 271, 'rotation': 90},
			{'startX': 495, 'startY': 257, 'rotation': 45},
			{'startX': 495, 'startY': 237, 'rotation': 45},
			{'startX': 495, 'startY': 218, 'rotation': 45},
			{'startX': 495, 'startY': 202, 'rotation': 45},
			{'startX': 495, 'startY': 185, 'rotation': 45},
			{'startX': 495, 'startY': 162, 'rotation': 45},
			{'startX': 495, 'startY': 146, 'rotation': 45},
			{'startX': 484, 'startY': 140, 'rotation': 0},
			{'startX': 478, 'startY': 134, 'rotation': 0},
			{'startX': 466, 'startY': 122, 'rotation': 0},
			{'startX': 456, 'startY': 113, 'rotation': 0},
			{'startX': 443, 'startY': 100, 'rotation': 0},
			{'startX': 430, 'startY': 87, 'rotation': 0},
			{'startX': 413, 'startY': 72, 'rotation': 0},
			{'startX': 395, 'startY': 77, 'rotation': 315},
			{'startX': 370, 'startY': 77, 'rotation': 315},
			{'startX': 345, 'startY': 77, 'rotation': 315},
			{'startX': 322, 'startY': 77, 'rotation': 315},
			{'startX': 300, 'startY': 77, 'rotation': 315},
			{'startX': 285, 'startY': 85, 'rotation': 270},
			{'startX': 270, 'startY': 102, 'rotation': 270},
			{'startX': 249, 'startY': 121, 'rotation': 270},
			{'startX': 233, 'startY': 137, 'rotation': 270},
			{'startX': 213, 'startY': 157, 'rotation': 270},
			{'startX': 196, 'startY': 174, 'rotation': 270},
			{'startX': 182, 'startY': 188, 'rotation': 270},
			{'startX': 164, 'startY': 206, 'rotation': 270},
			{'startX': 149, 'startY': 221, 'rotation': 270},
			{'startX': 135, 'startY': 235, 'rotation': 270},
			{'startX': 118, 'startY': 252, 'rotation': 270},
			{'startX': 103, 'startY': 267, 'rotation': 270},
			{'startX': 87, 'startY': 283, 'rotation': 270},
			{'startX': 77, 'startY': 293, 'rotation': 270},
			{'startX': 93, 'startY': 299, 'rotation': 180},
			{'startX': 101, 'startY': 306, 'rotation': 180},
			{'startX': 113, 'startY': 319, 'rotation': 180},
			{'startX': 126, 'startY': 332, 'rotation': 180},
			{'startX': 139, 'startY': 345, 'rotation': 180},
			{'startX': 154, 'startY': 360, 'rotation': 180},
			{'startX': 169, 'startY': 375, 'rotation': 180},
			{'startX': 182, 'startY': 388, 'rotation': 180},
			{'startX': 195, 'startY': 401, 'rotation': 180},
			{'startX': 211, 'startY': 417, 'rotation': 180}
			]
		}
    },
     mounted () {
     	this.drawStations()
    	setInterval(this.updateIndicatorArrays,3000)
    },
    methods: {
      updateIndicatorArrays() {
        var stationNames = this.stationNames
        var api_response = this.trainStatusData
        var vm = this

        // Step 1: Draw the map and the stations
        vm.clearDOM()

        // Step 2: Call API and generate array of triangle indicators to plot
		var leftBoundArray = []
		var rightBoundArray = []
		for (var train = 0; train < api_response.length; train++){

			var trainId = api_response[train].id
			var currLocation = api_response[train].current_station.station;

			var lastStation = -1
			var prevStation = -1
			if (api_response[train].previous_stations !== undefined) {
				if (api_response[train].previous_stations[0] !== undefined) {
			    	lastStation = api_response[train].previous_stations[0].station
				}
				if (api_response[train].previous_stations[1] !== undefined) {
			    	prevStation = api_response[train].previous_stations[1].station
			  	}
			}
			var indicatorArrays = generateObjectArray(currLocation, lastStation, prevStation, trainId, leftBoundArray, rightBoundArray,stationNames)

			leftBoundArray = indicatorArrays.leftBoundArray
			rightBoundArray = indicatorArrays.rightBoundArray
		}

	    vm.leftBoundArray = leftBoundArray
	    vm.rightBoundArray = rightBoundArray

		// Step 3: Update the polygonArray containing the points of the SVG objects
		vm.updatePolygonArray()

		// Step 4: Take the polygonArray and draw the SVG objects in the DOM
		vm.drawTrains()
      },
      updatePolygonArray() {
        this.polygonArray = generateObjects(this.clockWiseTrains, this.antiClockWiseTrains, this.leftBoundArray, this.rightBoundArray, this.idToPV)
      },
      drawStations(){
        drawStationBase(this.stationNames)
      },
      drawTrains(){
      	drawTrains(this.polygonArray)
      },
      clearDOM(){
      	clearDOM()
      }
    }
}

function pad(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

function drawStationBase(stationNames){
	var svg = d3.select("svg");
	var trainStations = svg.selectAll("circle").data(stationNames);

	trainStations.enter().append("circle")
		.attr("class", "train-station-circles")
		.attr("cy", function(d) { return d.circleY; })
		.attr("cx", function(d) { return d.circleX; })
		.attr("r", function(d) { return d.circleR; })
		.style("fill", "transparent")
		.on("mouseover", function(d){ // Display train details on hover
      		svg.select("#stationName-"+toCSSSelector(d.name)).classed("is-hidden", false)
    	})
    	.on("mouseout", function(d){
    		if (d.name !== "CE2 - Marina Bay" && d.name !== "CC1 - Dhoby Ghaut" && d.name !== "CC29 - HarbourFront"){
      			svg.select("#stationName-"+toCSSSelector(d.name)).classed("is-hidden", true)
    		}
    	})

	trainStations.enter().append("text")
	    .text( function(d) { return d.name; })
	    .attr("class", "train-station-names")
	    .attr("transform", function(d) {
	    	if (d.name === "CE2 - Marina Bay" || d.name === "CC29 - HarbourFront"){
	    		var xText = parseInt(d.circleX) - 0.5*this.textLength.baseVal.value;
	    		var yText = parseInt(d.circleY) + 17;
	    		return "translate(" + xText + "," + yText + ")";
	    	}
    		else {
    			var xText = parseInt(d.circleX) - 0.5*this.textLength.baseVal.value;
    			var yText = parseInt(d.circleY) - 8;
    			return "translate(" + xText + "," + yText + ")";
    		}
	    })
	    .attr("id", function(d) { return "stationName-"+toCSSSelector(d.name); })
	    .classed("is-hidden", function(d){
	    	if (d.name === "CE2 - Marina Bay" || d.name === "CC1 - Dhoby Ghaut" || d.name === "CC29 - HarbourFront"){
	    		return false
	    	}
	    	return true
	    })

}


// Draw trains given polygonArray
function drawTrains(polygonArray){
	var svg = d3.select("svg");
	var polygons = svg.selectAll("polygon").data(polygonArray).enter();

	polygons.append("polygon")
		.attr("points", "3,3 8,16 16,8")
		.style("fill", '#FAB809')
		.attr("transform", function(d) {
			return "translate(" + d.startX + ',' + d.startY + ") rotate(" + d.rotation + ")";
		})
		.on("mouseover", function(d){ // Display train details on hover
      		svg.select("#trainId-"+d.trainId).classed("is-hidden", false)
    	})
    	.on("mouseout", function(d){
      		svg.select("#trainId-"+d.trainId).classed("is-hidden", true)
    	})

	polygons.append("text")
	    .text( function(d) { return d.trainId; })
	    .attr("class", "train-id")
	    .attr("transform", function(d) {
	    	var xText = d.startX;
	    	var yText = d.startY - 0.5*this.textLength.baseVal.value;
	    	return "translate(" + xText + "," + yText + ")";
	    })
	    .attr("id", function(d) { return "trainId-"+d.trainId; })
	    .classed("is-hidden", true)
}

function generateObjects(clockWiseTrains, antiClockWiseTrains, leftBoundArray, rightBoundArray, idToPV){
	var polygonArray = []

	for (var i = 0; i < leftBoundArray.length; i++) {
		var stationIndex = leftBoundArray[i].stationIndex;
		polygonArray.push({
			'startX': clockWiseTrains[stationIndex].startX,
			'startY': clockWiseTrains[stationIndex].startY,
			'rotation': clockWiseTrains[stationIndex].rotation,
			'trainId': idToPV[leftBoundArray[i].trainId]
		})
	}

	for (var j = 0; j < rightBoundArray.length; j++) {
		var stationIndex = rightBoundArray[j].stationIndex;

		polygonArray.push({
			'startX': antiClockWiseTrains[stationIndex].startX,
			'startY': antiClockWiseTrains[stationIndex].startY,
			'rotation': antiClockWiseTrains[stationIndex].rotation,
			'trainId': idToPV[rightBoundArray[j].trainId]
		})
	}

	return polygonArray
}


// Map the station and direction into the SVG object that needs to be drawn
function generateObjectArray(currLocation, lastStation, prevStation, trainId, leftBoundArray, rightBoundArray, stationNames) {
  var currLocationIndex = findStationIndex(stationNames,currLocation);
  var lastStationIndex = findStationIndex(stationNames,lastStation);
  var prevStationIndex = findStationIndex(stationNames,prevStation);

  // If train is currently at a station
  if (currLocationIndex > -1) {

    // Check which direction it is going in:
    if (lastStationIndex < prevStationIndex && lastStationIndex > -1 && prevStationIndex > -1) {
      leftBoundArray.push({'stationIndex': currLocationIndex*2,
                            'trainId': trainId,
                            'currLocation': currLocation}); // Train is definitely going leftwards
    }
    else if (lastStationIndex > prevStationIndex && lastStationIndex > -1 && prevStationIndex > -1){
      rightBoundArray.push({'stationIndex': currLocationIndex*2,
                            'trainId': trainId,
                            'currLocation': currLocation}); // Train is definitely going rightwards
    }
    else { // There is no previous station
      leftBoundArray.push({'stationIndex': currLocationIndex*2,
                          'trainId': trainId,
                          'currLocation': currLocation}); // Just pick a random side first
    }
  }
  else { // Train is in between stations
    var nextStationName;
    var nextStationIndex;
    if (lastStationIndex < prevStationIndex && lastStationIndex > -1 && prevStationIndex > -1) {

      if (lastStationIndex == 0 || lastStationIndex == 2) { // If lastStation is Marina Bay or Dhoby Ghaut
        nextStationName = extractStationNameFromString(stationNames[lastStationIndex+1].name);
        nextStationIndex = lastStationIndex*2 + 1;
      }
      else {
        nextStationName = extractStationNameFromString(stationNames[lastStationIndex-1].name);
        nextStationIndex = lastStationIndex*2 - 1;
      }
      leftBoundArray.push({'stationIndex': nextStationIndex,
                          'trainId': trainId,
                          'currLocation': nextStationName + ' < ' + extractStationNameFromString(lastStation)}); // Train is definitely going leftwards
    }
    else if (lastStationIndex > prevStationIndex && lastStationIndex > -1 && prevStationIndex > -1){
      if (lastStationIndex == stationNames.length-1) { // If lastStation is HarbourFront
        nextStationName = extractStationNameFromString(stationNames[lastStationIndex-1].name);
        nextStationIndex = lastStationIndex*2 - 1;
      }
      else {
        nextStationName = extractStationNameFromString(stationNames[lastStationIndex+1].name);
        nextStationIndex = lastStationIndex*2 + 1;
      }
      rightBoundArray.push({'stationIndex': nextStationIndex,
                            'trainId': trainId,
                            'currLocation': extractStationNameFromString(lastStation) + ' > ' + nextStationName}); // Train is definitely going rightwards
    }
  }
  return {'leftBoundArray':leftBoundArray, 'rightBoundArray':rightBoundArray};
}

function findStationIndex(stationArray, name){
	for (var i = 0; i < stationArray.length; i++){
		if (stationArray[i].name === name) {
			return i
		}
	}
	return -1
}

// Split string to only contain station name
function extractStationNameFromString (stationString){
  if (stationString.split(' - ').length > 1){
    return stationString.split(' - ')[1];
  }
    return stationString
}


// Remove whitespace from station name
function toCSSSelector(string) {
	return extractStationNameFromString(string).replace(/ /gi, '')
}


// Delete all DOM svg objects
function clearDOM() {
  var svg = d3.select("svg");

  var polygon = svg.selectAll("polygon")
    .data([]);
  polygon.exit().remove();

  var text = svg.selectAll(".train-id")
    .data([]);
  text.exit().remove();
}

</script>

<style scoped>
img {
	position: relative;
	max-width: 100%;
	max-height: 100%;
}

svg {
	position: absolute;
	z-index: 20;
	width: 600px;
	height: 661.01px;
}

div {
	position:relative;
	width: 600px;
	height: auto;
}

.is-hidden {
	display: none;
}

.train-station-circles {
	fill: none;
}

.float {
	height: 20px;
	width: 20px;
	position: absolute;
}

.container {
	margin: auto;
}

.title-text {
	padding-top: 60px;
	padding-bottom: 20px;
	margin: auto;
}
</style>

<style>
.train-station-names {
	font-size: 12px !important;
}

.train-id {
	font-size: 12px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Trainmap.vue